export default __webpack_public_path__ + "static/media/separator.d451fafa.svg";